var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"#5c5c5c","position":"fixed","width":"100%","height":"100%"}},[_c('iframe',{staticClass:"iframe-console",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }